module.exports = __webpack_public_path__ + "img/thumbnail_BorneanElephant_j_albino.ba523628.png";